<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,700&display=swap');

#app {
  font-family: 'Montserrat', sans-serif;
  display: swap;
}

.data-section {
  background-color: #fff;
  margin: 20px 0;
  padding: 30px;
}

.space-btw {
  display: flex;
  justify-content: space-between;
}
</style>

<template>
  <v-app>
    <v-app-bar v-if='!this.$route.meta.public' app>
      <v-btn v-if='!drawer' @click.stop='drawer = !drawer' icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-toolbar-title class="headline text-uppercase">
        <span>All Ticket </span>
        <span class="font-weight-light">Dashboard</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        @click='logout()'
        icon
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-if='!this.$route.meta.public' v-model='drawer' floating app>
      <side-bar></side-bar>
    </v-navigation-drawer>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import SideBar from './components/SideBar'

export default {
  name: 'App',
  components: {
    SideBar
  },
  data: () => ({
    drawer: true
  }),
  methods: {
    logout () {
      console.log('logging out...')
      localStorage.removeItem('user-token')
      this.$router.push('/login')
    }
  }
}
</script>
